import React from 'react';
import MuiContainer, { ContainerProps as MuiContainerProps } from '@mui/material/Container';

export interface ContainerProps extends MuiContainerProps {}

const Container = React.forwardRef<React.ComponentRef<typeof MuiContainer>, ContainerProps>(
  function Container(props, ref) {
    return <MuiContainer ref={ref} {...props} />;
  },
);

export default Container;
